import { RosterLevelEnum } from '@wwe-portal/entities/roster.type';

export const levelEnumToLabel = {
  [RosterLevelEnum.B]: 'Bronze',
  [RosterLevelEnum.S]: 'Silver',
  [RosterLevelEnum.G]: 'Gold',
} as const;
